<template>
  <div class="index" :style="{ paddingTop: statusBar + 'rem' }">
    <!-- <Header ref="header" title="自然人用户注册" :back="true" left="" /> -->
    <div class="windowmain">
      <div class="boxmain">
      
        <div class="boxinput">
          <div class="boxend">
               <div class="endImg"><img src="@/views/image/userregister/icon_pass.png" alt="" /></div>
               <div class="endTxt">
                <p class="end_p1">注册成功！</p>
                <p  class="end_p2">登录用户名： {{userName}}</p>
                <p  class="end_p3 end_p4" v-if="isLoginCred=='true'">您可以直接使用 <span class="blodTip">{{registerType=='mobile'?'手机号':'邮箱'}}</span> 作为用户名登录</p>    
                <div  v-else>
                  <p  class="end_p3 end_p4">您可以登录PC系统点击右上角 “<span class="blodTip">用户名</span>”，进入用户名管理系统-登录凭证管理中  <span class="blodTip">{{registerType=='mobile'?'启用手机号登录':'启用邮箱登录'}}</span></p>   
                  <p  class=" end_p4" style="color:#00599c;" @click="goOptionText"> <van-icon style="margin-right:8px" name="info-o" /> 操作说明</p>
                </div>   
                </div> 
            </div>
        

          
        </div>
      </div>

      <div style="margin: 22px">
        <van-button
          type="primary"
          style="width:100%;height:1.07rem;font-size: 0.426667rem"
          size="small"
          @click="gologin"
          >去登录</van-button
        >
      </div>
      <div class="nav_btn" @click="goIndex">回首页</div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";

import {
  Col,
  Row,
  Button,
  Toast,
  Icon
} from "vant";

export default {
  name: "swuserregpsdend",
  data() {
    return {
      statusBar: 0,
      userName:this.$route.query.userName,
      isLoginCred:this.$route.query.isLoginCred,
      registerType:this.$route.query.registerType,
    };
  },
  mounted() {
    this.statusBar = this.$tool.statusBar(45);
  },

  methods: {
    goOptionText(){
      this.$router.push({
        path: "/optionText",
      });
    },
      gologin(){
         this.$nativeApi.jumpLogin(JSON.stringify({accountName:this.userName}))
      },
      goIndex(){
         this.$nativeApi.jumpHomePage(0)
      }
  },

  components: {
    Header,
    [Button.name]: Button,
    [Col.name]: Col,
    [Row.name]: Row,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/public.scss";
@import "@/views/css/userindex.scss";
.index{
 height: calc(100% - 45px);
    background: #fff;
}
.blodTip{
  color: #333;
  font-weight: bloder;
}
.windowmain {
  width: 100%;
   
  .boxmain {
    width: 100%;
    margin-bottom: 0px;
    .boxTitle {
      font-size: 16px;
      color: #333;
      font-weight: bold;
      margin: 20px 0px 10px 15px;
    }
  }
.nav_btn{
  text-align: center;
  font-size: 14px;
  text-decoration: underline;
  color: #096ac6;
}
  .boxinput {
 
    height: auto;
    border-radius: 4px;
    background: #fff;
    padding: 10px 0px;
    .boxend{
      width: 100%;
      text-align: center;
      padding-bottom: 20px;
      .endTxt{
        width: 100%;
        height: auto;
        background-image: url('~@/views/image/userregister/icon_endbg.png');
        background-size: cover;
      }
      .endImg{
        width: 36px;
        height: 36px;
        margin: 70px auto 0;
        margin-bottom: 6px;
        img{
          width: 100%;
        }
      }
      .end_p1,.end_p2{
        font-size: 15px;
        color: #333;
        line-height: 30px;
        font-weight: bold;
      }
      .end_p3{
        font-size: 12px;
        line-height: 18px;
        color: #666;

      }
      .end_p4{
        margin-top: 16px;
        padding: 0 20px;
        line-height: 24px;
      }
    }
 
  }
  .ftBton {
    padding: 0px 15px;
    font-size: 11px;
    color: #999;
  }
  ::v-deep .van-checkbox__icon {
    height: 0.9rem;
  }
  ::v-deep .van-checkbox__icon .van-icon {
    font-size: 11px;
  }
  ::v-deep .van-checkbox__label {
    color: #999;
    span {
      color: #096ac6;
    }
  }
}
</style>